export default __webpack_public_path__ + "static/media/gorgias.89f0051c.png";